export class DataTmp {
  content: string;
  element_id: string;
  element_name: string;
  element_type: string;
}

export const generateHtml = (data: any[]) => {
  const app = document.createElement('div');
  if (data.length > 0) {
    data.forEach(component => {
      const div = document.createElement('div');
      const title = document.createElement('h2');
      title.className = 'font-bold';
      title.textContent = component.title;
      div.appendChild(title);
      if (component.items?.length > 0) {
        const childOl = document.createElement('ul');
        childOl.className = 'go-report-list-decimal';
        for (let i = 0; i < component.items?.length; i++) {
          const childLi = document.createElement('li');
          const h3 = document.createElement('h3');
          h3.className = 'font-bold';
          h3.textContent = `${i + 1}. ${component.items[i].title}`;
          childLi.appendChild(h3);
          if (component.items[i].subitems?.length > 0) {
            component.items[i].subitems.forEach(element => {
              const pTag = document.createElement('p');
              pTag.textContent = element;
              childLi.appendChild(pTag);
            });
          }
          childOl.appendChild(childLi);
          div.appendChild(childOl);
        }
      }
      app.appendChild(div);
    });
  }
  return app;
};

export const generateBody = (data: any[], component?: string) => {
  const app = document.createElement('div');
  const listHtml = [];
  data.forEach(items => {
    const subApp = document.createElement('div');
    items.elements.forEach(item => {
      let childHtml = document.createElement('span');
      switch (item.element_type) {
        case 'heading':
          childHtml = document.createElement('h2');
          childHtml.textContent = item.content;
          break;
        case 'subheading':
          childHtml = document.createElement('h3');
          childHtml.textContent = item.content;
          break;
        case 'list':
          if (item.content?.length > 0) {
            childHtml = document.createElement('div');
            item.content.forEach(element => {
              const pTag = document.createElement('p');
              pTag.style.cssText = 'text-align: justify;font-style: italic;margin-bottom: 0px;';
              pTag.textContent = element;
              childHtml.appendChild(pTag);
            });
          }
          break;
        case 'list-of-list':
          if (item.content?.length > 0) childHtml = generateHtml(item.content);
          break;
        case 'table':
          childHtml = generateDataTable(item?.content?.schema, item?.content?.data);
          break;
        default:
          childHtml = document.createElement('p');
          childHtml.textContent = item.content;
      }
      subApp.appendChild(childHtml);
      app.appendChild(subApp);
    });
    listHtml.push(subApp.innerHTML);
  });

  return { html: listHtml, content: app.textContent, component: component };
};

export const generateDataTable = (schema, data) => {
  if (!schema || !data) return document.createElement('table');

  const tbl = document.createElement('table');
  tbl.className = 'go-report-table';

  const tblThread = document.createElement('thead');
  const row = document.createElement('tr');
  for (let j = 0; j < schema.fields.length; j++) {
    const th = document.createElement('th');
    const arrTmp = schema.fields[j]['name'].split('_');
    th.textContent = arrTmp
      .map(element => {
        return element.charAt(0).toUpperCase() + element.slice(1);
      })
      .join(' ');
    row.appendChild(th);
  }
  tblThread.appendChild(row);
  tbl.appendChild(tblThread);

  const tblBody = document.createElement('tbody');
  for (let i = 0; i < data.length; i++) {
    const dataLength = getMaxLength(data);
    const row = document.createElement('tr');
    for (let j = 0; j < schema.fields.length; j++) {
      const cell = document.createElement('td');
      const cellText = data[i][schema.fields[j]['name']];
      cell.style.cssText = `text-align: center; border: 1px solid #bbb;width:${switchWithTd(dataLength[schema.fields[j]['name']])}`;
      cell.textContent = cellText;
      row.appendChild(cell);
    }
    tblBody.appendChild(row);
  }

  tbl.appendChild(tblBody);
  return tbl;
};

export const generateReference = (data: any[], component?: string) => {
  const app = document.createElement('div');
  data.forEach(item => {
    let childHtml = document.createElement('span');
    switch (item.element_type) {
      case 'heading':
        childHtml = document.createElement('h2');
        childHtml.style.cssText = 'color: blue;';
        childHtml.textContent = item.content;
        break;
      case 'entry':
        childHtml = document.createElement('h3');
        childHtml.style.cssText = 'color: blue';
        childHtml.textContent = item.content;
        break;
      case 'list':
        childHtml = document.createElement('ul');
        if (item.element_name === 'reference_subentry') childHtml.style.cssText = 'margin-left: 5px;';
        if (item.contents?.length > 0) {
          item.contents.forEach(element => {
            const liTag = document.createElement('li');
            const pTag = document.createElement('p');
            pTag.textContent = element.title;
            const aTag = document.createElement('a');
            aTag.textContent = `https://goover.ai/detail-feed/${element.doc_id}`;
            liTag.appendChild(pTag);
            liTag.appendChild(aTag);
            childHtml.appendChild(liTag);
          });
        }
        break;
      default:
        childHtml = document.createElement('p');
        childHtml.textContent = item.content;
    }
    app.appendChild(childHtml);
  });

  return { html: app.innerHTML, content: app.textContent, component: component };
};

export const groupByNameHeading = data => {
  const arr = data?.elements.reduce((r, a) => {
    r[a.element_name] = r[a.element_name] || {};
    r[a.element_name] = a;
    return r;
  }, Object.create(null));
  return { data: arr, component: data.component_id, arrDocId: data.reference_doc_ids };
};

export const groupByNameTable = data => {
  const arr = data?.elements.reduce((r, a) => {
    r[a.element_name] = r[a.element_name] || [];
    if (a.element_name === 'table_of_section') r[a.element_name] = a;
    else r[a.element_name].push(a);
    return r;
  }, Object.create(null));
  return { data: arr, component: data.component_id, arrDocId: data.reference_doc_ids };
};

export const groupByComponentName = array => {
  if (array)
    return array.reduce((r, a) => {
      r[a.component_name] = r[a.component_name] || [];
      if (a.component_name === 'body_component') r[a.component_name].push(a);
      else r[a.component_name] = a;
      return r;
    }, Object.create(null));
  return undefined;
};

export const getMaxLength = array => {
  return array.reduce((r, a) => {
    Object.keys(a).forEach(key => {
      r[key] = r[key] || 0;
      r[key] = Math.max(r[key], a[key].length);
    });
    return r;
  }, Object.create(null));
};

const switchWithTd = (length: number) => {
  switch (true) {
    case length < 10:
      return '10px';
    case length > 10 && length < 50:
      return '40px';
    case length > 50:
      return '100px';
    default:
      return '10px';
  }
};
